import React from 'react';

const WHY_CHOOSE_ITEMS = [
    {
        id: '01',
        title: 'The Jaz Edge',
        description:
            'We build digital solutions that inspire growth, connect people, and deliver measurable success.',
    },
    {
        id: '02',
        title: 'Trusted by Businesses, Powered by Innovation',
        description:
            'Every project we deliver is backed by creativity, cutting-edge tech, and a commitment to excellence.',
    },
    {
        id: '03',
        title: 'Your Success, Our Priority',
        description:
            'From idea to execution, we focus on helping your brand grow — faster, smarter, and stronger.',
    },
];

const HomeTabOne = () => {
    return (
        <div className="why-choose-us-block row row--30 align-items-center">
            <div className="col-lg-6 mt_md--30 mt_sm--30">
                <div className="why-choose-us-content">
                    {WHY_CHOOSE_ITEMS.map((item) => (
                        <div className="why-choose-us-item" key={item.id}>
                            <h4 className="title">{item.title}</h4>
                            <p className="description">{item.description}</p>
                        </div>
                    ))}
                </div>
            </div>
            <div className="col-lg-6">
                <div className="service gallery-style text-start home-section-image-card">
                    <div className="inner">
                        <div className="image">
                            <img
                                src="./images/about/home-why-choose-us.png"
                                alt="Why choose Jaz Infotech for software development in Tirunelveli"
                                loading="lazy"
                                decoding="async"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HomeTabOne;
